import { gtmEventType, inquiryType } from '@Components/Utilities/SandhillsConstants';
import { gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import TranslationText from '@Components/Utilities/TranslationText';
import ActionButton from '@Components/Shared/ActionButton';
import { forwardRef } from 'react';
import translator from '@Components/Utilities/Translator';

const ContactOptions = forwardRef((props, ref) => {

    const contactOptions = [
        {
            buttonModel: {
                className: 'email-seller des-email-seller collapsible-contact-list-item',
                onClick: props.onOpenInquiryModal,
                iconClass: 'fas fa-envelope collapsible-contact-icon',
                ID: 'email-seller-' + (props.Id || props.PartID),
                buttonText: props.CustomEmailSellerTextForRental ? props.CustomEmailSellerTextForRental : props.CustomEmailSellerTextForRetail ? props.CustomEmailSellerTextForRetail : (props.IsForRentOnly || props.IsRY) ? <TranslationText tKey='sandhills.email'/> : <TranslationText tKey='sandhills.emailseller' />,
                inquiry: 'contactOptions-' + inquiryType.Email
            },
            shouldDisplay: props.ShowSendAMessage,
            buttonOrder: 1
        },
        {
            buttonModel: {
                className: 'check-availability des-check-availability collapsible-contact-list-item' + (!props.isMobile && props.BuyNowURL === '' ? '' : ' show-buy-now'),
                onClick: props.onCheckAvailability,
                iconClass: 'fas fa-check collapsible-contact-icon',
                ID: 'check-availability-' + (props.Id || props.PartID),
                buttonText: <TranslationText tKey='sandhills.checkavailability' />,
                inquiry: 'contactOptions-' + inquiryType.CheckAvailability
            },
            shouldDisplay: props.ShowCheckAvailability && !props.isParts,
            buttonOrder: 2
        },
        {
            buttonModel: {
                className: 'video-chat des-video-chat collapsible-contact-list-item',
                onClick: props.onVideoChat,
                iconClass: 'fas fa-video',
                ID: 'video-chat-' + (props.Id || props.PartID),
                buttonText: <TranslationText tKey='sandhills.videochat' />,
                inquiry: 'contactOptions-' + inquiryType.VideoChat
            },
            shouldDisplay: !props.isParts && props.ShowVideoChat,
            buttonOrder: 5,
        },
        {
            buttonModel: {
                className: 'facebook-messenger des-fb-messenger collapsible-contact-list-item',
                url: props.FBMessengerLink,
                target: '_blank',
                phoneType: 'Facebook Messaging',
                ID: props.Id || props.PartID,
                iconClass: 'fab fa-facebook-messenger collapsible-contact-icon',
                buttonText: <TranslationText tKey='sandhills.fbmessenger' />,
                ariaLabel: translator.translate('sandhills.fbmessenger') + " (" + translator.translate('sandhills.opensinanewtab') + ")",
                onClick: props.isParts ? () => gtmPushEvent(gtmEventType.messenger) : (e) => { gtmPushEvent(gtmEventType.messenger); props.onPhoneClickToTrack(e, props.FBMessengerID, 'Facebook Messaging'); }
            },
            shouldDisplay: typeof props.FBMessengerLink === 'string' && props.FBMessengerLink.length > 0,
            buttonOrder: 3
        },
        {
            buttonModel: {
                className: 'whatsapp des-whatsapp collapsible-contact-list-item',
                url: props.WhatsAppLink,
                target: '_blank',
                phoneType: 'WhatsApp Text Phone',
                iconClass: 'fab fa-whatsapp collapsible-contact-icon',
                ID: props.Id || props.PartID,
                buttonText: <TranslationText tKey='sandhills.whatsapp' />,
                ariaLabel: translator.translate('sandhills.whatsapp') + " (" + translator.translate('sandhills.opensinanewtab') + ")",
                onClick: props.isParts ? () => gtmPushEvent(gtmEventType.messenger) : (e) => { gtmPushEvent(gtmEventType.whatsApp); props.onPhoneClickToTrack(e, props.WhatsAppUnformattedPhoneNumber, 'WhatsApp Text Phone'); }
            },
            shouldDisplay: typeof props.WhatsAppLink === 'string' && props.WhatsAppLink.length > 0,
            buttonOrder: 4
        }
    ].filter(option => option.shouldDisplay);

    const getSortedContactOptions = () => {
        return contactOptions.sort((a, b) => (a.buttonOrder > b.buttonOrder) ? 1 : -1);
    };

    return (getSortedContactOptions().map(option =>
        <ActionButton key={option.buttonOrder + option.buttonModel.className} {...option.buttonModel} ref={ref} isDetailPage={props.isDetailPage} />)
    );
});

export default ContactOptions;